export default __webpack_public_path__ + "static/media/Icon_sospendi.5e96242a.svg";